import {useState} from 'react'

import {fetchUser} from '../data-fetchers/useUserByEmail'
import {UserExistenceStates} from './types'

// Imperative, per-email existence lookup for public forms: the trigger is deliberately manual
// (on blur / on mount, gated by session and form type), so this stays a lazy cache rather than a
// reactive query — but the actual IO goes through the shared fetchUser fetcher.
export const useExistingUserData = (email: string | null) => {
  const [data, setData] = useState({} as UserExistenceStates)

  const checkUser = async (email: string | null) => {
    if (!email || data[email]) {
      return
    }

    try {
      const {user} = await fetchUser({email, includeHistory: true})
      setData((prev) => ({
        ...prev,
        [email]: {userExists: Boolean(user), ...(user ? {userState: user.status} : {})},
      }))
    } catch {
      setData((prev) => ({...prev, [email]: {userExists: false}}))
    }
  }

  return [email ? data[email] : null, checkUser] as const
}
